import classNames from "classnames";
import React from "react";

export default function ({
  type,
  name,
  value,
  placeholder,
  onChange,
  required,
  maxEnable,
  maxHandler,
  maxName,
  className,
  readonly,
}) {
  const changeHandler = (event) => {
    let value = event.target.value;

    if (type === "number") {
      value = value.replace(/[^0-9]/g, "");
      event.target.value = value;
    }

    onChange(event);
  };

  return (
    <div className={classNames("custom__input", { [className]: !!className })}>
      <input
        type="text"
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={changeHandler}
        required={required}
        readOnly={readonly ? readonly : false}
      />
      {maxEnable && (
        <button onClick={maxHandler} type="button">
          {maxName || "Max"}
        </button>
      )}
    </div>
  );
}
